import { useContext } from 'react';

import { FaqPageContext } from '@/features/faq-page/context/faq-page-context';

const useFaqPageContext = () => {
  return useContext(FaqPageContext);
};

export default useFaqPageContext;
